import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";
import { toggleComponentErrorPage } from "../reducers/componentErrorSlice";
import store from "../store/configureStore";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_SUMMARY_SHEET;

export const getDocFileBase64 = createAsyncThunk(
    "/sheet/file/download",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/sheet/file/download", data, {
                headers: {
                },
            });
            if(response.status >= 500 && response.status < 600){
                store.dispatch(toggleComponentErrorPage({ show: true }));
            }
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)


export const getReport = createAsyncThunk(
    "/sheet/report",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/summary/summary-sheet/report", {
                startDate: data.startDate,
                endDate: data.endDate,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
            if(response.status == 500){
                store.dispatch(toggleComponentErrorPage({ show: true }));
            }
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const uploadReport = createAsyncThunk(
    "/sheet/report",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/summary/summary-sheet", data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if(response.status == 500){
                store.dispatch(toggleComponentErrorPage({ show: true }));
            }
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const deleteReport = createAsyncThunk(
    "/delete/report",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/summary/summary-sheet/report/delete", data);
            if(response.status == 500){
                store.dispatch(toggleComponentErrorPage({ show: true }));
            }
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)
